import React from 'react'

function renderError() {
  return <div />
}

export default renderError